import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 bg-brand-ink text-white relative overflow-hidden">
      <div className="dot-divider bg-brand-pink/30" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="bg-white/95 inline-block rounded-2xl p-4">
            <img
              src="https://customer-assets.emergentagent.com/job_bakery-b2b/artifacts/klxy49l5_Karpatka.png"
              alt="Cake World"
              className="h-24 w-auto object-contain"
            />
          </div>
          <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-xs font-ui">
            Premium desserts for hotels, restaurants and cafés — nationwide B2B distribution.
          </p>
        </div>

        <div>
          <div className="eyebrow text-brand-pink mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-white/80 font-ui">
            <li><Link data-testid="footer-catalog" to="/catalog" className="hover:text-brand-pink transition">Dessert Collection</Link></li>
            <li><Link data-testid="footer-sample-box" to="/sample-box" className="hover:text-brand-pink transition">Sample Box</Link></li>
            <li><Link data-testid="footer-wholesale" to="/wholesale" className="hover:text-brand-pink transition">B2B Solutions</Link></li>
            <li><Link data-testid="footer-partnerships" to="/partnerships" className="hover:text-brand-pink transition">Partnerships</Link></li>
            <li><Link data-testid="footer-gallery" to="/gallery" className="hover:text-brand-pink transition">Gallery</Link></li>
            <li><Link data-testid="footer-blog" to="/blog" className="hover:text-brand-pink transition">Blog</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-brand-pink mb-4">Company</div>
          <ul className="space-y-2 text-sm text-white/80 font-ui">
            <li><Link data-testid="footer-about" to="/about" className="hover:text-brand-pink transition">About</Link></li>
            <li><Link data-testid="footer-contact" to="/contact" className="hover:text-brand-pink transition">Contact</Link></li>
            <li><Link data-testid="footer-admin" to="/admin/login" className="hover:text-brand-pink transition">Admin</Link></li>
          </ul>
          <div className="eyebrow text-brand-pink mb-4 mt-6">Legal</div>
          <ul className="space-y-2 text-sm text-white/80 font-ui">
            <li><Link data-testid="footer-privacy" to="/legal/privacy-policy" className="hover:text-brand-pink transition">Privacy Policy</Link></li>
            <li><Link data-testid="footer-terms" to="/legal/terms-conditions" className="hover:text-brand-pink transition">Terms & Conditions</Link></li>
            <li><Link data-testid="footer-cookies" to="/legal/cookie-policy" className="hover:text-brand-pink transition">Cookie Policy</Link></li>
            <li><Link data-testid="footer-notice" to="/legal/notice" className="hover:text-brand-pink transition">Legal Notice</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-brand-pink mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-white/80 font-ui">
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-brand-pink shrink-0" /> <span>info@cakeworldusa.com</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-brand-pink shrink-0" /> <span>+1 (623) 324-7530</span></li>
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-brand-pink shrink-0" /> <span>Phoenix, AZ — nationwide shipping</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-3 font-ui">
          <div>© {new Date().getFullYear()} Cake World USA. All rights reserved.</div>
          <div>Crafted for hospitality partners.</div>
        </div>
      </div>
    </footer>
  );
}
